export const validateGrid = (rawGrid: string, prefix: string) => {
  const grid = String(rawGrid);

  const len = grid.length;
  if (len !== 19) {
    return false;
  }

  // validating code against prefix
  const prefixAccepted = grid.startsWith(prefix);
  if (!prefixAccepted) {
    return false;
  }

  const charsToVal = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const checksum = parseInt(grid.substring(len - 2));
  const chars = grid.split('');
  let sum = 0;
  for (let idx = 0; idx < 17; idx++) {
    const char = chars[idx].toUpperCase();
    const n = 17 - idx;
    const tbn = Math.pow(2, n);
    const val = charsToVal.indexOf(char);
    const valxtbn = val * tbn;

    sum += valxtbn;
  }

  const sm37 = sum % 37;
  const n38msm37 = 38 - sm37;
  const calculatedChecksum = n38msm37 % 37;

  return checksum === calculatedChecksum;
};
